import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './filter_dropdown.module.scss';

export const FilterDropdown: FC = ({ children }) => (
  <div className={classNames(styles.container)}>{children}</div>
);
